import src from "IMAGE";
export default { src, width: 78, height: 96, blurWidth: 0, blurHeight: 0};
